module.exports = __webpack_public_path__ + "img/streaming-tv-app.ac09e91c.webp";